import { ErrorScreen } from '@homestake/shared/ui';
import { env, Game, Layout, Providers } from '@homestake/towers';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import Clarity from '@microsoft/clarity';
import { ErrorBoundary, reactErrorHandler } from '@sentry/react';
import { StrictMode } from 'react';
import { type Container, createRoot } from 'react-dom/client';
import './i18n';
import './instrument';
import './styles.css';

Clarity.init(env.VITE_MICROSOFT_CLARITY_PROJECT_ID);

createRoot(document.getElementById('root') as Container, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    {/* TODO: Error fallback design */}
    <Providers>
      <ErrorBoundary fallback={<ErrorScreen />}>
        <Layout>
          <Game />
        </Layout>
      </ErrorBoundary>
    </Providers>
  </StrictMode>
);
